// IMPORT PACKAGE REFERENCES
import React from 'react';

// IMPORT PROJECT REFERENCES
import { PharmacyDetails } from '../../DeviceBrowser/PharmacyDetails';

// COMPONENT

export const PharmacyPage = ({ match }) => {
    return (<div className="animated fadeIn">
                <PharmacyDetails pharmacyId={match.params.pharmacyId} />
            </div>);
}